// VarnasaaraVisualization.js - Production component for varnasaara visualization using Option 2 design

import React from 'react';
import { Accordion, Badge } from 'react-bootstrap';
import './VarnasaaraVisualization.css';

const VarnasaaraVisualization = ({ data, loading, error }) => {
  if (loading) {
    return (
      <div className="varnasaara-loading">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">विश्लेषणम्...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="varnasaara-error">
        <div className="alert alert-danger" role="alert">
          <h6>त्रुटिः (Error)</h6>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!data || !data.syllables || data.syllables.length === 0) {
    return (
      <div className="varnasaara-empty">
        <div className="text-center text-muted">
          <p>कोऽपि परिणामो नास्ति (No results available)</p>
        </div>
      </div>
    );
  }

  const renderComponent = (component, wordIndex, syllableIndex, componentIndex) => {
    const eventKey = `${wordIndex}-${syllableIndex}-${componentIndex}`;
    
    return (
      <Accordion.Item 
        key={componentIndex} 
        eventKey={eventKey} 
        className={`component-card ${component.type}`}
      >
        <Accordion.Header className="component-header">
          <div className="d-flex justify-content-between align-items-center w-100 me-3">
            <span className="component-label">{component.character}</span>
            <div className="component-badges">
              {component.metadata?.maatra && (
                <Badge bg="secondary" className="me-1">
                  {component.metadata.maatra}
                </Badge>
              )}
              {component.metadata?.anga && (
                <Badge bg="info" className="me-1">
                  {component.metadata.anga}
                </Badge>
              )}
              {component.metadata?.svara && (
                <Badge bg="primary" className="me-1">
                  {component.metadata.svara}
                </Badge>
              )}
              {component.metadata?.hasDwitva && (
                <Badge bg="success" className="me-1">द्वित्व</Badge>
              )}
              {component.metadata?.specialMarkers?.map((marker, idx) => (
                <Badge key={idx} bg="dark" className="me-1">
                  {marker}
                </Badge>
              ))}
            </div>
          </div>
        </Accordion.Header>
        
        <Accordion.Body className="component-description">
          {component.type === 'vowel' && component.description?.preSvara ? (
            <div>
              <span>{component.description.preSvara || ''}</span>
              {component.description.svara && (
                <div><span className="svara-text">{component.description.svara}</span></div>
              )}
              <span>{component.description.postSvara || ''}</span>
            </div>
          ) : (
            <div>
              {typeof component.description === 'string' 
                ? component.description 
                : (component.description?.full || '\u25cc')
              }
            </div>
          )}
        </Accordion.Body>
      </Accordion.Item>
    );
  };

  return (
    <div className="varnasaara-visualization">
      <div className="word-display mb-3">
        <h5>{data.word}</h5>
      </div>
      
      {data.syllables.map((syllable, syllableIndex) => (
        <div key={syllableIndex} className="syllable-block mb-4">
          <div className="syllable-header">
            <h6 className="syllable-text">{syllable.text}</h6>
          </div>
          
          <Accordion 
            defaultActiveKey={syllable.components.map((_, i) => `0-${syllableIndex}-${i}`)} 
            className="component-accordion" 
            alwaysOpen
          >
            {syllable.components.map((component, componentIndex) => 
              renderComponent(component, 0, syllableIndex, componentIndex)
            )}
          </Accordion>
          
          {syllable.virama && (
            <div className="virama-text mt-2">
              {syllable.virama}
            </div>
          )}
        </div>
      ))}
      
      {data.finalVirama && (
        <div className="virama-text mt-2">
          {data.finalVirama}
        </div>
      )}
    </div>
  );
};

export default VarnasaaraVisualization;
